export type FunctionType<ArgumentsType extends unknown[], ReturnType> = (...args: ArgumentsType) => Promise<ReturnType>;

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const promiseDebounce = <ArgumentsType extends unknown[], ReturnType>(fn: FunctionType<ArgumentsType,ReturnType>,
                                                                          wait: number) => {
   if (!Number.isFinite(wait)) {
      throw new TypeError('Expected `wait` to be a finite number');
   }

   let timer: any = null;
   let debounceTimedOut = false;
   let currentPromise: Promise<ReturnType> | undefined;

   const currentPromiseResolver = () => {
      timer = null;
      debounceTimedOut = true;
   };

   return (...args: ArgumentsType) => {

      if (timer !== null) {
         window.clearTimeout(timer);
      }

      if (currentPromise === undefined) {

         currentPromise = new Promise((resolve, reject) => {

            (async () => {
               while (!debounceTimedOut) {
                  await sleep(100);
               }

               // @ts-ignore
               fn.apply(this, args).then((result) => {
                  currentPromise = undefined;
                  debounceTimedOut = false;
                  resolve(result);
                  return result;
               }).catch((reason) => {
                  currentPromise = undefined;
                  debounceTimedOut = false;
                  reject(reason)
               });
            })();
         });
      }

      if (debounceTimedOut) {
         return currentPromise;
      }

      timer = window.setTimeout(currentPromiseResolver, wait);

      return currentPromise;
   };
}
